import React, {forwardRef, useEffect, useRef, useState} from "react";
import {TextArea} from "./Textarea/TextArea";
import {Input} from "./Input/Input";
import {TInputElement, TTextFieldProps} from "./types";
import styles from './TextField.module.scss'
import {classNames} from "@shared/utils";

export const TextField = forwardRef<HTMLDivElement, TTextFieldProps>(
    ({multiline, label, icon, error, ...props}, ref) => {

        const InputElement = multiline ? TextArea : Input

        const inputRef = useRef<HTMLInputElement | HTMLTextAreaElement>(null);
        const handleClickLabel = () => {
            inputRef.current?.focus();
        };

        const [isFocused, setIsFocused] = useState(false);

        const onFocusInputHandler = (e: React.FocusEvent<TInputElement>) => {
            setIsFocused(true);
            if (props.onFocus) props.onFocus(e);
        }

        const onBlurInputHandler = (e: React.FocusEvent<TInputElement>) => {
            setIsFocused(false);
            if (props.onBlur) props.onBlur(e);
        }

        const [isCountSymbolsWrapper, setIsCountSymbolsWrapper] = useState(false)

        const classNameField = classNames(
            styles.field,
            isFocused || !!props.value ? styles.field_state_isFocused_true : '',
            !!label ? styles.field_state_isLabel_true : ''
        )

        useEffect(() => {
            setIsCountSymbolsWrapper(true)
            const closeCountSymbolsWrapper = setTimeout(() => setIsCountSymbolsWrapper(false), 1000)

            return () => {
                clearTimeout(closeCountSymbolsWrapper)
            }
        }, [props.value]);

        const classNamesRoot = classNames(
            styles.root,
            {[styles.root_error]: !!error}
        )

        return (
            <div className={classNamesRoot} ref={ref}>
                {!multiline && icon &&
                    <img src={icon} alt={'icon'}/>
                }
                <div className={classNameField} >
                    {label && (
                        <label onClick={handleClickLabel}>
                            {error || label}
                        </label>
                    )}
                    <InputElement
                        // isLabel={!!label}
                        onFocus={onFocusInputHandler}
                        onBlur={onBlurInputHandler}
                        {...props}
                    />
                    {isCountSymbolsWrapper && props.maxLength &&
                        <div className={styles.counter}>
                            {`${props.value.length}/${props.maxLength}`}
                        </div>
                    }
                </div>
            </div>
        )
    })